<template>
  <div class="Help">
    <Content></Content>
  </div>
</template>

<script>
import App from '@/mixins/App';

export default {
  name: 'Help',
  components: {
    Content : () => import("./Content.vue")
  },
  mixins: [ App ]
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Help/Help.vue